//This import is needed for the Quickstart-Codehub integration, the content of the index.tsx is now in bootstrap.tsx and is imported into the index file to avoid an eager loading error when rendering. More documentation can be found here: https://webpack.js.org/concepts/module-federation/#troubleshooting
const CHUNK_RELOAD_FLAG = 'codehub-chunk-reload'

import('./bootstrap')
  .then(() => sessionStorage.removeItem(CHUNK_RELOAD_FLAG))
  .catch(error => {
    // A stale bundle can reference a chunk id that a newer deploy already removed from the CDN,
    // which the CDN's SPA fallback answers with index.html instead of a 404. Reload once to
    // pick up the current index.html/runtime instead of leaving the user on a dead page.
    const isChunkLoadError =
      error?.name === 'ChunkLoadError' || /Loading chunk [\d]+ failed/i.test(error?.message ?? '')
    if (isChunkLoadError && !sessionStorage.getItem(CHUNK_RELOAD_FLAG)) {
      sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1')
      window.location.reload()
      return
    }
    throw error
  })

export {}
